var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectStyles, selectPages, selectAppContent, selectMedia } from "@adm-media/adam-store-plugin";
import classNames from "classnames";
import "./Slider.scss";
import "./../Hero/Hero.scss";
import { SanitizeHtml } from "../../ui/SanitizeHtml/SanitizeHtml";
import useBreakpoint from "../../../hooks/useBreakpoint";
import Typography from "../../ui/Typography/Typography";
import { useEpisodesToShowInHomepage } from "../../../hooks/useEpisodesToShowInHomepage";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import { DEFAULT_SLIDER_DELAY, DEFAULT_SLIDER_EFFECT, DEFAULT_SLIDER_PAGINATION_TYPE, DEFAULT_SLIDER_SPEED, MOBILE_BREAKDOWN } from "../../../utils/constants";
import Button from "../../ui/Buttons/Button";
import { OpenLoginModalButton } from "../../ui/Buttons/OpenLoginModalButton/OpenLoginModalButton";
import usePages from "../../../hooks/usePages";
// import { AutoplayOptions } from "swiper/types";
var Slider = function () {
    var _a;
    var windowSize = useBreakpoint().windowSize;
    var styles = useSelector(selectStyles);
    var heroVideoMobileBreakpoint = useSelector(selectStyles).heroVideoMobileBreakpoint;
    var contents = useSelector(selectAppContent);
    var _b = useEpisodesToShowInHomepage({ contents: contents, styles: styles }), episodesToShowInHomepage = _b.episodesToShowInHomepage, formattedLiveDate = _b.formattedLiveDate, formattedVODDate = _b.formattedVODDate, vodDurationToDisplay = _b.vodDurationToDisplay, hideNextEpisodeSchedule = _b.hideNextEpisodeSchedule;
    var media = useSelector(selectMedia);
    var pages = useSelector(selectPages);
    var _c = usePages(), filter = _c.filter, getMedia = _c.getMedia, handleLink = _c.handleLink;
    var _d = useState(false), firstLoadOfEpisodes = _d[0], setFirstLoadOfEpisodes = _d[1];
    useEffect(function () {
        if ((episodesToShowInHomepage === null || episodesToShowInHomepage === void 0 ? void 0 : episodesToShowInHomepage.length) > 0)
            setFirstLoadOfEpisodes(true);
    }, [episodesToShowInHomepage]);
    var slides = filter("highlighted");
    var sliderMedia = [];
    if (!styles.disable_default_first_slide) {
        if (media === null || media === void 0 ? void 0 : media.body_background_image_desktop) {
            sliderMedia.push(__assign(__assign({}, media.body_background_image_desktop), { keyname: "highlighted_media" }));
        }
        if (media === null || media === void 0 ? void 0 : media.body_background_image_mobile) {
            sliderMedia.push(__assign(__assign({}, media.body_background_image_mobile), { keyname: "highlighted_media_mobile" }));
        }
        //hideNextEpisodeSchedule
        slides = __spreadArray([
            {
                id: -1,
                is_login: true,
                title: contents === null || contents === void 0 ? void 0 : contents.event_title,
                subtitle: contents === null || contents === void 0 ? void 0 : contents.sub_title,
                cta_text: contents.login,
                media: sliderMedia,
                abstract: !hideNextEpisodeSchedule ? (_jsxs(_Fragment, { children: [formattedLiveDate && (_jsxs(Typography.Title, __assign({ level: 4, className: "slide-content__extra--live" }, { children: [!!contents.live_datetime_title && (_jsxs(_Fragment, { children: [_jsx(SanitizeHtml, { stringToSanitize: contents.live_datetime_title, tag: styles.date_on_new_line ? "div" : "span" }), " "] })), formattedLiveDate] }))), formattedVODDate && (_jsxs(Typography.Title, __assign({ level: 4, className: "slide-content__extra--vod" }, { children: [!!contents.vod_datetime_title && (_jsxs(_Fragment, { children: [_jsx(SanitizeHtml, { stringToSanitize: contents.vod_datetime_title, tag: styles.date_on_new_line ? "div" : "span" }), " "] })), formattedVODDate, contents.up_to && !!vodDurationToDisplay && contents.hours && (_jsxs("span", __assign({ className: "" }, { children: [" ", contents.up_to, " ", vodDurationToDisplay === null || vodDurationToDisplay === void 0 ? void 0 : vodDurationToDisplay.toFixed(0), " ", contents.hours] })))] })))] })) : null
            }
        ], slides, true);
    }
    var sliderEffect = styles.slider_effect || DEFAULT_SLIDER_EFFECT;
    var sliderDelay = Number(styles.slider_delay) || DEFAULT_SLIDER_DELAY;
    var sliderModules = [Pagination, Navigation];
    if (!styles.disable_autoplay)
        sliderModules.push(Autoplay);
    if (sliderEffect === "fade")
        sliderModules.push(EffectFade);
    var autoplay = !styles.disable_autoplay ? { delay: sliderDelay, pauseOnMouseEnter: true } : undefined;
    var isMobile = windowSize.width <= (heroVideoMobileBreakpoint || MOBILE_BREAKDOWN);
    var sliderHeight = isMobile
        ? "calc(".concat(styles.hero_height_mobile, " - var(--navbar-height-mobile))")
        : "calc(".concat(styles.hero_height_desktop, " - var(--navbar-height-desktop))");
    return (_jsx("div", __assign({ className: classNames("slider", (_a = {}, _a["animation-ready"] = firstLoadOfEpisodes, _a)), style: { width: "100%", height: sliderHeight } }, { children: _jsx(Swiper
        // modules={[Navigation, Pagination, Scrollbar, A11y]}
        // spaceBetween={50}
        // slidesPerView={3}
        // navigation
        // pagination={{ clickable: true }}
        // scrollbar={{ draggable: true }}
        // onSwiper={(swiper) => console.log("swiper", swiper)}
        // onSlideChange={() => console.log("slide change")}
        , __assign({ 
            // modules={[Navigation, Pagination, Scrollbar, A11y]}
            // spaceBetween={50}
            // slidesPerView={3}
            // navigation
            // pagination={{ clickable: true }}
            // scrollbar={{ draggable: true }}
            // onSwiper={(swiper) => console.log("swiper", swiper)}
            // onSlideChange={() => console.log("slide change")}
            effect: sliderEffect, speed: parseInt(styles.slider_speed || DEFAULT_SLIDER_SPEED), pagination: {
                type: styles.pagination_type || DEFAULT_SLIDER_PAGINATION_TYPE,
                clickable: true
            }, loop: !styles.disable_loop, navigation: !styles.disable_navigation, modules: sliderModules, autoplay: autoplay, className: "adam-swiper" }, { children: slides === null || slides === void 0 ? void 0 : slides.map(function (slide) {
                var mediaDesktop = getMedia({ filter: "highlighted_media", item: slide });
                var mediaMobile = getMedia({ filter: "highlighted_media_mobile", item: slide });
                var mediaSrc = mediaDesktop === null || mediaDesktop === void 0 ? void 0 : mediaDesktop.url;
                var mediaMimeDesktop = mediaDesktop === null || mediaDesktop === void 0 ? void 0 : mediaDesktop.mime;
                var mediaSrcMobile = mediaMobile === null || mediaMobile === void 0 ? void 0 : mediaMobile.url;
                var mediaMimeMobile = mediaMobile === null || mediaMobile === void 0 ? void 0 : mediaMobile.mime;
                var bgImage = isMobile && mediaSrcMobile ? mediaSrcMobile : mediaSrc;
                var activeMime = isMobile && mediaSrcMobile ? mediaMimeMobile : mediaMimeDesktop;
                var isVideo = activeMime === null || activeMime === void 0 ? void 0 : activeMime.startsWith("video/");
                var _a = handleLink(slide), linkTarget = _a.linkTarget, handleCardClick = _a.handleCardClick;
                var loginButton = slide.is_login ? _jsx(OpenLoginModalButton, { className: "slide-content__cta-btn" }) : null;
                var abstract = slide.abstract ? _jsx("div", __assign({ className: "slide-content__extra" }, { children: slide.abstract })) : null;
                return (_jsx(SwiperSlide, { children: _jsxs("div", __assign({ className: "slide-content", style: !isVideo ? { backgroundImage: "url(".concat(bgImage, ")") } : undefined }, { children: [isVideo && bgImage && _jsx("video", { className: "slide-content__video", src: bgImage, autoPlay: true, muted: true, loop: true, playsInline: true }), _jsx(Typography.Text, __assign({ className: "slide-content__title hero-animated-element" }, { children: _jsx(SanitizeHtml, { stringToSanitize: slide === null || slide === void 0 ? void 0 : slide.title, tag: "span" }) })), _jsx(Typography.Text, __assign({ className: "slide-content__subtitle hero-animated-element" }, { children: _jsx(SanitizeHtml, { stringToSanitize: slide.subtitle, tag: "span" }) })), abstract, _jsxs("div", __assign({ className: "slide-content__cta-wrapper" }, { children: [loginButton, handleCardClick ? (_jsx(Button, __assign({ onClick: handleCardClick, target: linkTarget, className: "slide-content__cta-btn" }, { children: slide.slide_cta_text || "More info" }))) : null] }))] })) }, "home-slide-".concat(slide.id)));
            }) })) })));
};
export default Slider;
